module.exports = __webpack_public_path__ + "static/media/reading_dark.c0c3634e.svg";